import { useFeatureIsOn } from "@growthbook/growthbook-react";

export const HUBSPOT_MEETING_TEAM_NOTES_FLAG = "hubspot-meeting-team-notes";
export const HUBSPOT_TASKS_INTEGRATION_FLAG = "hubspot-tasks-integration";

export function useHubspotTasksIntegrationFeatureFlagOn(): boolean {
	return useFeatureIsOn(HUBSPOT_TASKS_INTEGRATION_FLAG);
}
